"use strict";
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchStatsEntry_Unit = exports.protobufPackage = void 0;
exports.protobufPackage = "match_stats";
var MatchStatsEntry_Unit;
(function (MatchStatsEntry_Unit) {
    /** ABSOLUTE - e.g. for shots count */
    MatchStatsEntry_Unit[MatchStatsEntry_Unit["ABSOLUTE"] = 0] = "ABSOLUTE";
    /** PERCENT - e.g. for possession */
    MatchStatsEntry_Unit[MatchStatsEntry_Unit["PERCENT"] = 1] = "PERCENT";
    MatchStatsEntry_Unit[MatchStatsEntry_Unit["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MatchStatsEntry_Unit || (exports.MatchStatsEntry_Unit = MatchStatsEntry_Unit = {}));
//# sourceMappingURL=match_stats.js.map